// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import CollaboratorEdit from '../components/CollaboratorEdit';
import {actions as AccountsAction} from '../duck';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    collaborator: state.accountsConfig.collaborator,
    fetchError: state.accountsConfig.fetchError,
    isSaving: state.accountsConfig.isSaving,
    savingSuccess: state.accountsConfig.saveSuccess,
    saveError: state.accountsConfig.saveError,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...AccountsAction,
      },
      dispatch
    )
)(CollaboratorEdit);
